export default __webpack_public_path__ + "static/guy-on-cycle-cb331168bdf9d98db798361cbecd2bd5.png";